<button class="btn" [class.btn-success]="role.open && isInFuture" [class.btn-danger]="!role.open || !isInFuture" [disabled]="!role.open || disabled || !isInFuture" (click)="apply()">
	{{ role.open && isInFuture ? 'Apply Now' : 'Closed' }}
</button>
